import { Box, Typography } from "@mui/material"

type NoteBadgeProps = {
  text: string
  position: "top-left" | "bottom-left"
  backgroundColor: string
}

const NoteBadge = ({ text, position, backgroundColor }: NoteBadgeProps) => {
  const positionStyles = {
    "top-left": {
      top: 0,
      left: 0,
      borderRadius: "0 0 4px 0",
    },
    "bottom-left": {
      bottom: 0,
      left: 0,
      borderRadius: "0 4px 0 0",
    },
  }

  return (
    <Box
      sx={{
        position: "absolute",
        ...positionStyles[position],
        bgcolor: backgroundColor,
        color: "white",
        px: 1,
        py: 1,
      }}
    >
      <Typography
        sx={{
          fontSize: "12px",
          lineHeight: "16px",
          fontWeight: 600,
          display: "block",
        }}
      >
        {text}
      </Typography>
    </Box>
  )
}

export default NoteBadge
